export default {
  CUSTOMER_INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY: Symbol.for('CUSTOMER_INVESTMENT_PRODUCT_FUND_TYPE_REPOSITORY'),
  GET_MODERATE_IS_CONTRACTED_QUERY: Symbol.for('GET_MODERATE_IS_CONTRACTED_QUERY'),
  MODERATE_IS_CONTRACTED_STATE_MANAGER: Symbol.for('MODERATE_IS_CONTRACTED_STATE_MANAGER'),
  SEARCH_INVESTMENT_PRODUCTS_CONTRACTED_BY_CUSTOMER: Symbol.for('SEARCH_INVESTMENT_PRODUCTS_CONTRACTED_BY_CUSTOMER'),
  CUSTOMER_INVESTMENT_PRODUCT_FUND_TYPE_STATE_MANAGER: Symbol.for('CUSTOMER_INVESTMENT_PRODUCT_FUND_TYPE_STATE_MANAGER'),
};
